import React from "react";
import "./Header.css"; // Caso você queira separar os estilos
import { Link } from "react-router-dom";

function Header() {
  return (
    <header className="header">
      <div className="container header-container">
        <img src="inti.svg" alt="Inti Logo" className="logo" />
        <nav>
          <ul className="nav-links">
            <li>
              <Link to="/">Início</Link>
            </li>

            <li>
              <Link to="/contact">Contato</Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
